import {
 ADDPRODUCT,
 PRODQUETYDECREMENT,
 PRODQUETYINCREMENT,
} from "./actionTypes";
import initialState from "./initialState";
import shortid from "shortid";
const homeReducer = (state = initialState, action) => {
 switch (action.type) {
  case ADDPRODUCT:
   const { name, category, prodImg, prodPrice, prodQuantity } = action.payload;
   return [
    ...state,
    {
     id: shortid.generate(),
     name,
     category,
     prodImg,
     prodPrice,
     prodQuantity,
    },
   ];

  case PRODQUETYINCREMENT:
   return state?.map((prod) => {
    const { id, increment } = action.payload || {};
    if (prod.id === id) {
     return {
      ...prod,
      prodQuantity: Number(prod.prodQuantity) + increment,
     };
    }
    return { ...prod };
   });
  case PRODQUETYDECREMENT:
   return state?.map((prod) => {
    const { id, decrement } = action.payload || {};
    if (prod.id === id) {
     return {
      ...prod,
      prodQuantity: Number(prod.prodQuantity) - decrement,
     };
    }
    return { ...prod };
   });
  default:
   return state;
 }
};

export default homeReducer;
